module.exports = __webpack_public_path__ + "static/media/chat01.43e030cc.png";